import React from 'react';
import '../styles/Services.css';
import '../styles/ScrollAnimation.css';
import ScrollAnimation from '../utils/ScrollAnimation';

const SERVICES = [
  {
    title: 'Full-Stack Development',
    summary:
      'End-to-end Django, Rails, and React applications — from API design through polished UI delivery.',
    tags: ['REST & GraphQL', 'Postgres models', 'Integrations'],
  },
  {
    title: 'AI Feature Integration',
    summary:
      'Practical OpenAI and Gemini features wired into real product flows with monitoring and guardrails.',
    tags: ['Chat pipelines', 'Tool orchestration', 'Usage controls'],
  },
  {
    title: 'Performance Engineering',
    summary:
      'Query tuning, caching, and background jobs for systems that need to hold up under real load.',
    tags: ['N+1 fixes', 'Redis / Celery', 'Load reduction'],
  },
  {
    title: 'Security Hardening',
    summary:
      'Auth, encryption, and multi-tenant hardening for consumer and B2B products that handle sensitive data.',
    tags: ['AuthN / AuthZ', 'Audit practices', 'Secrets hygiene'],
  },
  {
    title: 'Cloud & DevOps',
    summary:
      'Deployments, containers, and CI/CD on AWS, Heroku, and VPS — environments that stay predictable.',
    tags: ['Docker', 'Pipelines', 'Monitoring'],
  },
  {
    title: 'Ongoing Maintenance',
    summary:
      'Bug triage, feature iterations, and code review after launch so shipping stays a cadence, not a crisis.',
    tags: ['Bug fixes', 'Iterations', 'Reviews'],
  },
];

const Services = () => {
  return (
    <section id="services" className="services section">
      <div className="container">
        <ScrollAnimation className="fade-up">
          <div className="services-header">
            <h2 className="section-title">What I Do</h2>
            <div className="divider-glow" />
            <p className="section-subtitle">
              Crafting digital products that merge reliable engineering with clear user outcomes.
            </p>
          </div>
        </ScrollAnimation>

        <div className="services-grid">
          {SERVICES.map((service, index) => (
            <ScrollAnimation key={service.title} className={`fade-up stagger-${(index % 4) + 1}`}>
              <article className="service-card">
                <div className="service-card-glow" aria-hidden="true" />
                <h3>{service.title}</h3>
                <p>{service.summary}</p>
                <ul>
                  {service.tags.map((tag) => (
                    <li key={tag}>{tag}</li>
                  ))}
                </ul>
              </article>
            </ScrollAnimation>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
